import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/contatti`;

export default function ContactForm() {
  const [form, setForm] = useState({
    nome: "",
    email: "",
    oggetto: "",
    messaggio: "",
    consenso: false,
    website: "",
  });
  const [sending, setSending] = useState(false);

  const set = (key) => (e) =>
    setForm((f) => ({
      ...f,
      [key]: e && e.target ? (e.target.type === "checkbox" ? e.target.checked : e.target.value) : e,
    }));

  const onConsenso = (checked) => setForm((f) => ({ ...f, consenso: !!checked }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (sending) return;
    if (!form.consenso) {
      toast.error("È necessario acconsentire al trattamento dei dati.");
      return;
    }
    setSending(true);
    try {
      await axios.post(API, form, { timeout: 15000 });
      toast.success("Messaggio inviato con successo. Luisa ti risponderà al più presto.");
      setForm({ nome: "", email: "", oggetto: "", messaggio: "", consenso: false, website: "" });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(
        typeof detail === "string"
          ? detail
          : "Invio non riuscito. Riprova tra qualche istante."
      );
    } finally {
      setSending(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-ink/25 py-3 text-sm outline-none transition-colors focus:border-bordeaux placeholder:text-muted3 rounded-none";

  return (
    <form onSubmit={onSubmit} noValidate={false} data-testid="contact-form" className="space-y-8">
      <input
        type="text"
        name="website"
        value={form.website}
        onChange={set("website")}
        className="hidden"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-8">
        <div>
          <label htmlFor="nome" className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted3">
            Nome *
          </label>
          <input
            id="nome"
            type="text"
            required
            minLength={2}
            value={form.nome}
            onChange={set("nome")}
            placeholder="Il tuo nome"
            className={inputCls}
            data-testid="contact-name-input"
          />
        </div>
        <div>
          <label htmlFor="email" className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted3">
            Email *
          </label>
          <input
            id="email"
            type="email"
            required
            value={form.email}
            onChange={set("email")}
            placeholder="La tua email"
            className={inputCls}
            data-testid="contact-email-input"
          />
        </div>
      </div>

      <div>
        <label htmlFor="oggetto" className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted3">
          Oggetto
        </label>
        <input
          id="oggetto"
          type="text"
          value={form.oggetto}
          onChange={set("oggetto")}
          placeholder="Di cosa vuoi parlarmi?"
          className={inputCls}
          data-testid="contact-subject-input"
        />
      </div>

      <div>
        <label htmlFor="messaggio" className="font-mono text-[10px] uppercase tracking-[0.25em] text-muted3">
          Messaggio *
        </label>
        <textarea
          id="messaggio"
          required
          minLength={5}
          rows={5}
          value={form.messaggio}
          onChange={set("messaggio")}
          placeholder="Scrivimi…"
          className={`${inputCls} resize-none`}
          data-testid="contact-message-input"
        />
      </div>

      <div className="flex items-start gap-3">
        <Checkbox
          id="consenso"
          checked={form.consenso}
          onCheckedChange={onConsenso}
          className="mt-0.5 data-[state=checked]:bg-bordeaux data-[state=checked]:border-bordeaux"
          data-testid="contact-consent-checkbox"
        />
        <label htmlFor="consenso" className="text-xs leading-relaxed text-ink2">
          Acconsento al trattamento dei miei dati per essere ricontattato/a, come descritto nella{" "}
          <Link to="/privacy" className="link-underline text-bordeaux">
            privacy policy
          </Link>
          . *
        </label>
      </div>

      <button
        type="submit"
        disabled={sending}
        className="inline-flex items-center gap-3 bg-ink text-paper px-9 py-4 text-[11px] uppercase tracking-[0.25em] transition-colors hover:bg-bordeaux disabled:opacity-50"
        data-testid="contact-submit-button"
      >
        {sending ? "Invio in corso…" : "Invia il messaggio"}
      </button>
    </form>
  );
}
